// frontend/src/services/recordingActivity.js
//
// Vet om en inspelning pågår i den här fliken (även pausad). Används för att
// aldrig avbryta en inspelning, t.ex. med en omdirigering till inloggningen.

// Efter stopp ska sista klippet hinna skrivas till kön och sessionen markeras klar.
const AFTER_STOP_GRACE_MS = 30000;

let activeCount = 0;
let lastEndedAt = 0;

// Markera en pågående inspelning. Returnerar funktionen som markerar den som slut.
export function markRecordingActive() {
  activeCount += 1;
  return () => {
    activeCount -= 1;
    lastEndedAt = Date.now();
  };
}

export function isRecordingBusy() {
  return activeCount > 0 || Date.now() - lastEndedAt < AFTER_STOP_GRACE_MS;
}
